import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInvite = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#a)",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M9 3.5h.5v-1H9zm5.833 4.833a.5.5 0 0 0-1 0zM10.8 7.79a.5.5 0 0 0-.266-.964zM15.167 4a1.833 1.833 0 0 1-1.834 1.833v1A2.833 2.833 0 0 0 16.167 4zm-1.834 1.833A1.833 1.833 0 0 1 11.5 4h-1a2.833 2.833 0 0 0 2.833 2.833zM11.5 4c0-1.013.82-1.833 1.833-1.833v-1A2.833 2.833 0 0 0 10.5 4zm1.833-1.833c1.013 0 1.834.82 1.834 1.833h1a2.833 2.833 0 0 0-2.834-2.833zM2.167 11V5h-1v6zm10.166 1.5H3.667v1h8.666zm-8.666-9H9v-1H3.667zm10.166 4.833V11h1V8.333zm-1.5 5.167a2.5 2.5 0 0 0 2.5-2.5h-1a1.5 1.5 0 0 1-1.5 1.5zM1.167 11a2.5 2.5 0 0 0 2.5 2.5v-1a1.5 1.5 0 0 1-1.5-1.5zm1-6a1.5 1.5 0 0 1 1.5-1.5v-1a2.5 2.5 0 0 0-2.5 2.5zM8 7.167a9.46 9.46 0 0 1-6.016-2.148l-.634.774A10.46 10.46 0 0 0 8 8.167zm2.534-.342A9.5 9.5 0 0 1 8 7.167v1c.969 0 1.908-.132 2.8-.378z"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "a",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M0 0h16v16H0z"
		})
	}) })]
});
export default SvgInvite;
